import { useCallback, useEffect, useState } from "react";

import { useParams } from "react-router";
import { activeServiceId, pageIndicator } from "../apollo";
import { EditBannerProps } from "../constants/enum";
import { useMe } from "../hooks/useMe";

import { Button } from "../components/button";

import { useListBannerMain } from "../hooks/useListBannerMain";
import update from "immutability-helper";
import { MainImage } from "../components/main-image";
import { useCrBannerMain } from "../hooks/useCrBannerMain";
import { MainVideo } from "../components/main-video";
import { useEditBannerMainIndex } from "../hooks/useEditBannerMainIndex";
import { CardBanner } from "../components/CardBanner";
import { useEditBannerMain } from "../hooks/useEditBannerMain";
import { Link } from "react-router-dom";
import {
  BannerMainType,
  CrBannerMainInput,
  CrBannerMainMutation,
  EditBannerMainIndexInput,
  EditBannerMainIndexMutation,
  EditBannerMainInput,
  EditBannerMainMutation,
  ListBannerMainQuery,
  ListLinkServiceQuery,
} from "../generated/graphql";
import { ArrElement } from "./sub-admin-up-product-detail";
import { useListLinkService } from "../hooks/useListLinkService";

const style = {
  width: "100%",
};

type ListBannerMain = ArrElement<
  ListBannerMainQuery["listBannerMain"]["bannerMain"]
>;

type upMainsProps = ListBannerMain & { file?: any };

export interface Item extends ListBannerMain {}
export const SubAdminEditBannerMain: React.FC<EditBannerProps> = ({
  tabs,
  setTabHandler,
}) => {
  const params = useParams();
  const [mainData, setMainData] = useState<Item[]>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const [linkServiceData, setLinkServiceData] = useState<ListLinkServiceQuery["listLinkService"]["linkservice"]>([]);
  const [selectedLinkService, setSelectedLinkService] = useState<number | null>(null);
  const { data: me } = useMe();
  // 서비스가 배정된 계정(수퍼관리자가 아닌 계정)은 자신에게 배정된 서비스의 메인배너만
  // 보고/편집할 수 있도록 선택 가능한 서비스 목록을 좁힌다. 배정된 서비스가 없으면
  // (수퍼관리자) 전체 서비스를 그대로 보여준다.
  const allowedServiceIds =
    me?.me.linkServices && me.me.linkServices.length > 0
      ? me.me.linkServices.map((service) => service.id)
      : null;
  const visibleLinkServiceData = allowedServiceIds
    ? linkServiceData?.filter((service) =>
        allowedServiceIds.includes(service.id)
      )
    : linkServiceData;
  // --- 배너 이미지, 비디오 생성 ---
  const onCrCompleted = async (data: CrBannerMainMutation) => {
    const {
      crBannerMain: { ok, err },
    } = data;
    if (ok) {
      await refetch();
    } else {
      alert(err);
    }
  };
  const [crBannerMain, { loading: crBannerMainLoading }] = useCrBannerMain(
    onCrCompleted
  );
  const crBannerMainHandler = (typeValue: BannerMainType) => {
    if (!crBannerMainLoading) {
      const crBannerMainInput: CrBannerMainInput = {
        mainType: typeValue,
        linkServiceId: selectedLinkService || 0,
      };
      crBannerMain({ variables: { input: crBannerMainInput } });
    }
  };
  //

  // --- 메인배너 리스트 Sortable ---
  const onEditIndexCompleted = async (data: EditBannerMainIndexMutation) => {
    const {
      editBannerMainIndex: { ok, err },
    } = data;
    if (ok) {
      await refetch();
    }
  };
  const [
    editBannerMainIndex,
    { loading: editBannerMainIndexLoading },
  ] = useEditBannerMainIndex(onEditIndexCompleted);
  const editBannerMainIndexHandler = (bannerMainId: number, index: number) => {
    const editBannerMainIndexInput: EditBannerMainIndexInput = {
      index,
      bannerMainId,
    };
    editBannerMainIndex({ variables: { input: editBannerMainIndexInput } });
  };

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setMainData((prevCards: Item[]) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as Item],
        ],
      })
    );
  }, []);
  const renderCard = useCallback(
    (card: { id: number; name?: string | null }, index: number) => {
      return (
        <CardBanner
          key={card.id}
          index={index}
          id={card.id}
          name={card.name}
          // moveCard={moveCard}
          editBannerMainIndex={editBannerMainIndexHandler}
        />
      );
    },
    []
  );

  ///  --- URL 등록 ---

  const onEditCompleted = async (data: EditBannerMainMutation) => {
    const {
      editBannerMain: { ok, err },
    } = data;
    if (ok) {
      await refetch();
    } else {
      alert(err);
      return;
    }
    setUploading(false);
  };
  const [
    editBannerMain,
    { loading: editBannerMainLoading },
  ] = useEditBannerMain(onEditCompleted);
  const editBannerMainHandler = (
    bannerMainId: number,
    link: string | null,
    title: string | null,
    note: string | null,
    alt: string | null,
    isFree: boolean,
    isRes: boolean,
    isEvent: boolean,
    isOnePlusOne: boolean
  ) => {
    const editBannerMainInput: EditBannerMainInput = {
      bannerMainId,
      link,
      title,
      note,
      alt,
      isFree,
      isRes,
      isEvent,
      isOnePlusOne,
    };
    editBannerMain({ variables: { input: editBannerMainInput } });
  };

  const onListLinkServiceCompleted = async (data: ListLinkServiceQuery) => {
    const {
      listLinkService: { ok, linkservice, err },
    } = data;
    if (ok && linkservice) {
      setLinkServiceData(linkservice);
    } else {
      console.log(err);
    }
  };
  useEffect(() => {
    if (selectedLinkService) {
      listBannerMain({ variables: { input: { linkServiceId: selectedLinkService || 0 } } });
    }
  }, [selectedLinkService]);
  const [listLinkService, { data: listLinkServiceData, loading: listLinkServiceLoading, refetch: listLinkServiceRefetch }] = useListLinkService(onListLinkServiceCompleted);

  // 선택 가능한 서비스 목록(visibleLinkServiceData)이 정해지면, 관리자페이지 상단에서
  // 선택해둔 "현재 서비스"(activeServiceId)가 그 안에 있으면 그것을 기본값으로 쓰고,
  // 없거나(수퍼관리자 등) 현재 선택값이 더 이상 목록에 없으면 목록의 첫 서비스로 맞춘다.
  useEffect(() => {
    if (!visibleLinkServiceData || visibleLinkServiceData.length === 0) return;
    const stillVisible = visibleLinkServiceData.some(
      (service) => service.id === selectedLinkService
    );
    if (stillVisible) return;
    const preferred = activeServiceId();
    const preferredVisible = visibleLinkServiceData.find(
      (service) => service.id === preferred
    );
    setSelectedLinkService(
      preferredVisible ? preferredVisible.id : visibleLinkServiceData[0].id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleLinkServiceData?.map((service) => service.id).join(",")]);

  // --- 메인배너 리스트 ---
  const onListCompleted = async (data: ListBannerMainQuery) => {
    const {
      listBannerMain: { ok, bannerMain, err },
    } = data;
    if (ok && bannerMain) {
      setMainData(bannerMain);
    } else {
      console.log(err);
    }
  };
  const [
    listBannerMain,
    { data: listBannerMainData, loading, refetch },
  ] = useListBannerMain(onListCompleted);
  
  useEffect(() => {
    pageIndicator("events");
    
    listLinkService({ variables: { input: { page: 1, search: "" } } });
    
  }, []);
  return (
    <div className="shadow-lg min-w-[1160px] h-fix-content max-w-[1160px]  2xl:max-w-[1623px]  bg-white">
      <div className="pl-9 pr-11 py-8 space-y-4 min-h-[800px]">
        <div className="relative grid grid-cols-[1fr] gap-x-4">
          <div className="min-h-[600px]">
            <div className="flex flex-wrap justify-end">
              {visibleLinkServiceData && visibleLinkServiceData.map((linkService) => (
                <button key={linkService.id} className={`ml-4 min-w-[50px] px-2 h-[30px] bg-[#8B8C8C] text-white rounded-lg ${selectedLinkService === linkService.id ? "bg-[#007AFF] text-white" : "bg-[#8B8C8C] text-white"}`} onClick={() => setSelectedLinkService(linkService.id)}>{linkService.name}</button>
              ))}
            </div>
            <div className="font-bold text-[#4F4F4F] text-base">
        
              메인배너
              <button
                className="ml-4 min-w-[50px] px-2 h-[30px] bg-[#8B8C8C] text-white rounded-lg"
                onClick={() => crBannerMainHandler(BannerMainType.Image)}
              >
                생성
              </button>
              {/* <button
                  className="ml-4 min-w-[50px] px-2 h-[30px] bg-[#8B8C8C] text-white rounded-lg"
                  onClick={() => crBannerMainHandler(BannerMainType.Video)}
                >
                  비디오
                </button> */}
              {loading && (
                <div className="pt-5">상세정보를 불러오는 중입니다</div>
              )}
              <p className="py-2">순서 재배치</p>
              <div style={style} className="overflow-auto space-y-4">
                {listBannerMainData?.listBannerMain.bannerMain &&
                  listBannerMainData.listBannerMain.bannerMain.map((card, i) =>
                    renderCard(card, i)
                  )}
              </div>
            </div>
          </div>
          {/* <div className="w-full">
            <div className="grid grid-cols-3 gap-8">
              {loading && <div>정보를 불러오는 중입니다</div>}
              {!loading &&
                listBannerMainData?.listBannerMain.bannerMain &&
                listBannerMainData.listBannerMain.bannerMain.map((banner) => (
                  <>
                    <MainImage
                      bannerMain={banner}
                      refetch={refetch}
                      index={banner.index}
                      mainHandler={mainHandler}
                    />
                  </>
                ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
